import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { FRONTEND_STATE_LOCATION_HOVERED } from './locationFinder.actionTypes';

export const rightPanelHoverMarker = (rowId: SpreadsheetRowId | null) => ({
  type: FRONTEND_STATE_LOCATION_HOVERED,
  payload: {
    rowId,
  },
}) as const;
